import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../provider/authProvider";
import Navbar from "../components/navbar/Navbar.tsx";
import Footer from "../components/footer/Footer.tsx";
import Menu from "../components/menu/Menu.tsx";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

export const ProtectedRoute = () => {
    const { token } = useAuth();
    const queryClient = new QueryClient();
    
    const Layout = ({ children }) => {
        return (
            <div className="main">
                <Navbar />
                <div className="container">
                    <div className="menuContainer">
                        <Menu />
                    </div>
                    <div className="contentContainer">
                        <QueryClientProvider client={queryClient}>
                            <Outlet />
                        </QueryClientProvider>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }

    if (!token) {
        return <Navigate to="/login" />
    }

    return <Layout />
}